(function () {
  angular.module("akitabox.room", [
    "ui.router",
    "akitabox.constants",
    "akitabox.core.constants",
    "akitabox.core.router",
    "akitabox.room.detail",
    "akitabox.room.list",
  ]);
})();
